import { useFirebaseData } from "../../@shared/hooks/useFirebaseData";
import { Collections } from "../../@core/constants/FirebasePaths";

export const useSettings = ({ loadData = false }) => {
  const db = useFirebaseData({
    loadData,
    collectionPath: Collections.settings._path,
  })

  const getToS =  async ()=> {
    return await db.docWithId(Collections.settings._path + "/termsOfService")
  }

  const updateToS = async (data: any) => {
    return await db.update("termsOfService", data)
  }

  return {
    getToS,
    updateToS
  }
}
